// Client/client-vite/src/config/index.ts


// Warn if base URL missing during dev
if (!import.meta.env.VITE_API_URL && import.meta.env.DEV) {
    console.warn("[config] ⚠️ Missing VITE_API_URL — defaulting to https://api.idscrm.com/api");
}

export const API_URL = (import.meta.env.VITE_API_URL || "https://api.idscrm.com/api").replace(/\/$/, "");
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || "https://api.idscrm.com";
export const IMAGE_BASE = import.meta.env.VITE_IMAGE_BASE_URL || "https://images.autocitymag.com/photos";

export const AUTH_BASE = `${API_URL}/auth`;
export const AUTH_CUSTOMERS_BASE = `${API_URL}/auth`;
export const AUTH_DEALERS_BASE = `${API_URL}/dealers-auth`;
export const AUTH_DEALERS_PENDING_BASE = `${API_URL}/dealers-pending-auth`;
export const DEALER_BASE = `${API_URL}/dealers`;
export const CUSTOMER_BASE = `${API_URL}/customers`;

// Global IDS platform dealer ID used for consumer accounts (no dealership affiliation)
export const PLATFORM_DEALER_ID = 0;

export const IS_DEV = import.meta.env.DEV;
export const NODE_ENV = import.meta.env.VITE_NODE_ENV;
